// Angular imports
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';
import { CiraHelpService } from '../../_services/shared-services/cira-help.service';
import { PortfolioHelperService } from '../_services/portfolio-helper.service';

// Component imports
import { UserPortfolioBaseComponent } from '../_base/user-portfolio-base.component';

@Component({
    selector: 'app-user-portfolio-main',
    templateUrl: './user-portfolio-main.component.html',
    styleUrls: ['./user-portfolio-main.component.scss']
})
export class UserPortfolioMainComponent {
    pageTitle: string;
    helpLink: string;
    loadingVisible: boolean;
    isSmallScreen: boolean;
    routeComponent: UserPortfolioBaseComponent;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly screenService: ScreenService,
        private readonly ciraHelpService: CiraHelpService,
        private readonly portfolioService: PortfolioHelperService
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const currentRoute = this.route.snapshot.routeConfig.children.find((r) => {
                    return event.url.endsWith(r.path);
                });
                if (!!currentRoute && !!currentRoute.data) {
                    this.pageTitle = currentRoute.data.pageTitle;
                    this.helpLink = this.ciraHelpService.getHelpLink(null, currentRoute.data.helpKey, null);
                }
            }
        });
        this.portfolioService.onLoadingEvent().subscribe((flag) => {
            setTimeout(() => (this.loadingVisible = flag), 10);
        });
        this.updateScreenSize();
    }

    onRouteActivate(routeComponent: UserPortfolioBaseComponent): void {
        this.routeComponent = routeComponent;
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
        this.screenService.changed.subscribe(() => (this.isSmallScreen = this.screenService.isSmallScreen()));
    }
}
